






























































import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({})
export default class RegisterForm extends Vue {
  @Ref('registerForm') registerForm!: Vue;

  validRegisterForm = true;
  registered = false;

  registerData = {
    email: '',
    fullName: '',
    password: '',
    passwordConfirmation: '',
  };

  registerDataValidations = {
    email: [(v: string) => !!v || 'E-mail is required', (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
    fullName: [(v: string) => !!v || 'Full name is required'],
    password: [
      (v: string) => {
        if (!v.length) {
          return 'Password is required';
        } else if (v.length < 6) {
          return 'Password have to be longer then 5 characters';
        } else {
          return true;
        }
      },
    ],
    passwordConfirmation: [
      (v: string) => !!v || 'Password Confirmation is required',
      (v: string) => v === this.registerData.password || 'Passwords do not match',
    ],
  };

  async submitRegister() {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.registerForm as any).validate()) {
      // TODO: Move to action, set axios
      try {
        const res = await fetch(`${process.env.VUE_APP_API_URL}/auth/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.registerData.email,
            fullName: this.registerData.fullName,
            password: this.registerData.password,
          }),
        });
        if (res.status === 200) {
          this.registered = true;
          this.$router.push('/auth/presenter/login');
        }
      } catch (e) {
        console.warn(e);
      }
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }
}
